import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  de: {
    // Navigation
    nav_home: 'Home',
    nav_about: 'Über uns',
    nav_events: 'Veranstaltungen',
    nav_archive: 'Archiv',
    nav_membership: 'Mitglied werden',
    nav_contact: 'Kontakt',
    nav_admin: 'Admin',
    
    // Home
    hero_slogan: 'Zwei Kulturen, eine Leidenschaft',
    hero_subtitle: 'Förderung der deutsch-italienischen Freundschaft seit 2011',
    founded: 'Gegründet',
    hero_cta: 'Mitglied werden',
    hero_events: 'Veranstaltungen entdecken',
    
    // About
    about_title: 'Über Amitalia',
    about_intro: 'Seit 2011 bringt Amitalia die Kulturen Deutschlands und Italiens zusammen.',
    about_mission_title: 'Unsere Mission',
    about_mission: 'Wir fördern den kulturellen Austausch, die Freundschaft und das gegenseitige Verständnis zwischen deutschen und italienischen Bürgern durch Veranstaltungen, Sprachkurse und gemeinsame Projekte.',
    about_values_title: 'Unsere Werte',
    about_value_1: 'Kulturelle Vielfalt',
    about_value_2: 'Freundschaft & Respekt',
    about_value_3: 'Tradition & Innovation',
    about_team_title: 'Unser Team',
    about_team_text: 'Unser engagiertes Team aus deutschen und italienischen Mitgliedern arbeitet ehrenamtlich für die Ziele des Vereins.',
    
    // Events
    events_title: 'Veranstaltungen',
    events_upcoming: 'Kommende Veranstaltungen',
    events_no_upcoming: 'Derzeit keine kommenden Veranstaltungen.',
    events_location: 'Ort',
    events_date: 'Datum',
    events_details: 'Details',
    
    // Archive
    archive_title: 'Archiv',
    archive_subtitle: 'Eine Reise durch unsere Geschichte',
    archive_select_year: 'Jahr auswählen',
    archive_no_events: 'Keine Veranstaltungen in diesem Jahr.',
    archive_all_years: 'Alle Jahre',
    
    // Membership
    membership_title: 'Mitglied werden',
    membership_subtitle: 'Werden Sie Teil unserer Gemeinschaft',
    membership_benefits_title: 'Vorteile der Mitgliedschaft',
    membership_benefit_1: 'Zugang zu exklusiven Veranstaltungen',
    membership_benefit_2: 'Ermäßigungen bei Sprachkursen',
    membership_benefit_3: 'Networking mit Gleichgesinnten',
    membership_benefit_4: 'Aktive Mitgestaltung des Vereinslebens',
    membership_types_title: 'Mitgliedschaftsarten',
    membership_regular: 'Ordentliche Mitgliedschaft',
    membership_regular_price: '60€ / Jahr',
    membership_student: 'Studentenmitgliedschaft',
    membership_student_price: '30€ / Jahr',
    membership_family: 'Familienmitgliedschaft',
    membership_family_price: '100€ / Jahr',
    membership_form_title: 'Mitgliedsantrag',
    
    // Contact
    contact_title: 'Kontakt',
    contact_subtitle: 'Wir freuen uns auf Ihre Nachricht',
    contact_form_title: 'Schreiben Sie uns',
    contact_address: 'Adresse',
    contact_email: 'E-Mail',
    contact_phone: 'Telefon',
    
    // Form fields
    form_first_name: 'Vorname',
    form_last_name: 'Nachname',
    form_name: 'Name',
    form_email: 'E-Mail',
    form_phone: 'Telefon',
    form_address: 'Adresse',
    form_city: 'Stadt',
    form_postal: 'Postleitzahl',
    form_country: 'Land',
    form_subject: 'Betreff',
    form_message: 'Nachricht',
    form_membership_type: 'Mitgliedschaftsart',
    form_submit: 'Absenden',
    form_success: 'Erfolgreich gesendet!',
    form_error: 'Ein Fehler ist aufgetreten.',
    
    // Footer
    footer_rights: 'Alle Rechte vorbehalten',
    footer_privacy: 'Datenschutz',
    footer_imprint: 'Impressum',
    
    // Admin
    admin_login: 'Admin-Login',
    admin_username: 'Benutzername',
    admin_password: 'Passwort',
    admin_dashboard: 'Dashboard',
    admin_events: 'Veranstaltungen verwalten',
    admin_contacts: 'Kontaktanfragen',
    admin_memberships: 'Mitgliedsanträge',
    admin_logout: 'Abmelden',
    admin_add_event: 'Neue Veranstaltung',
    admin_edit_event: 'Bearbeiten',
    admin_delete_event: 'Löschen',
    admin_save: 'Speichern',
    admin_cancel: 'Abbrechen',
  },
  it: {
    // Navigation
    nav_home: 'Home',
    nav_about: 'Chi siamo',
    nav_events: 'Eventi',
    nav_archive: 'Archivio',
    nav_membership: 'Diventa socio',
    nav_contact: 'Contatti',
    nav_admin: 'Admin',
    
    // Home
    hero_slogan: 'Due culture, una sola passione',
    hero_subtitle: 'Promuovere l\'amicizia italo-tedesca dal 2011',
    founded: 'Fondata',
    hero_cta: 'Diventa socio',
    hero_events: 'Scopri gli eventi',
    
    // About
    about_title: 'Chi siamo',
    about_intro: 'Dal 2011, Amitalia unisce le culture della Germania e dell\'Italia.',
    about_mission_title: 'La nostra missione',
    about_mission: 'Promuoviamo lo scambio culturale, l\'amicizia e la comprensione reciproca tra cittadini tedeschi e italiani attraverso eventi, corsi di lingua e progetti comuni.',
    about_values_title: 'I nostri valori',
    about_value_1: 'Diversità culturale',
    about_value_2: 'Amicizia e rispetto',
    about_value_3: 'Tradizione e innovazione',
    about_team_title: 'Il nostro team',
    about_team_text: 'Il nostro team dedicato di membri tedeschi e italiani lavora volontariamente per gli obiettivi dell\'associazione.',
    
    // Events
    events_title: 'Eventi',
    events_upcoming: 'Prossimi eventi',
    events_no_upcoming: 'Nessun evento in programma al momento.',
    events_location: 'Luogo',
    events_date: 'Data',
    events_details: 'Dettagli',
    
    // Archive
    archive_title: 'Archivio',
    archive_subtitle: 'Un viaggio attraverso la nostra storia',
    archive_select_year: 'Seleziona anno',
    archive_no_events: 'Nessun evento in questo anno.',
    archive_all_years: 'Tutti gli anni',
    
    // Membership
    membership_title: 'Diventa socio',
    membership_subtitle: 'Entra a far parte della nostra comunità',
    membership_benefits_title: 'Vantaggi dell\'iscrizione',
    membership_benefit_1: 'Accesso a eventi esclusivi',
    membership_benefit_2: 'Sconti sui corsi di lingua',
    membership_benefit_3: 'Networking con persone affini',
    membership_benefit_4: 'Partecipazione attiva alla vita associativa',
    membership_types_title: 'Tipi di iscrizione',
    membership_regular: 'Iscrizione ordinaria',
    membership_regular_price: '60€ / anno',
    membership_student: 'Iscrizione studenti',
    membership_student_price: '30€ / anno',
    membership_family: 'Iscrizione famiglia',
    membership_family_price: '100€ / anno',
    membership_form_title: 'Modulo di iscrizione',
    
    // Contact
    contact_title: 'Contatti',
    contact_subtitle: 'Non vediamo l\'ora di sentirvi',
    contact_form_title: 'Scrivici',
    contact_address: 'Indirizzo',
    contact_email: 'E-mail',
    contact_phone: 'Telefono',
    
    // Form fields
    form_first_name: 'Nome',
    form_last_name: 'Cognome',
    form_name: 'Nome',
    form_email: 'E-mail',
    form_phone: 'Telefono',
    form_address: 'Indirizzo',
    form_city: 'Città',
    form_postal: 'CAP',
    form_country: 'Paese',
    form_subject: 'Oggetto',
    form_message: 'Messaggio',
    form_membership_type: 'Tipo di iscrizione',
    form_submit: 'Invia',
    form_success: 'Inviato con successo!',
    form_error: 'Si è verificato un errore.',
    
    // Footer
    footer_rights: 'Tutti i diritti riservati',
    footer_privacy: 'Privacy',
    footer_imprint: 'Impressum',
    
    // Admin
    admin_login: 'Login Admin',
    admin_username: 'Nome utente',
    admin_password: 'Password',
    admin_dashboard: 'Dashboard',
    admin_events: 'Gestisci eventi',
    admin_contacts: 'Richieste di contatto',
    admin_memberships: 'Richieste di iscrizione',
    admin_logout: 'Esci',
    admin_add_event: 'Nuovo evento',
    admin_edit_event: 'Modifica',
    admin_delete_event: 'Elimina',
    admin_save: 'Salva',
    admin_cancel: 'Annulla',
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('amitalia-language');
    return saved || 'de';
  });

  useEffect(() => {
    localStorage.setItem('amitalia-language', language);
  }, [language]);

  const t = (key) => {
    return translations[language][key] || key;
  };

  const toggleLanguage = (lang) => {
    setLanguage(lang);
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage: toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
